module.exports = __webpack_public_path__ + "img/block_opened_blue.a1ea0e29.svg";